import { NavLink } from 'react-router-dom';
import { useContext, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import '../styles/Topbar.css';

export default function Topbar() {
  const { roles, user, logout } = useContext(AuthContext);
  const canSee = roles.includes('ADMIN') || roles.includes('DOCTOR');

const [mostrarCierre, setMostrarCierre] = useState(false);
  const [cierre, setCierre] = useState([]);
  const [loadingCierre, setLoadingCierre] = useState(false);

  const abrirCierre = async () => {
    setMostrarCierre(true);
    setLoadingCierre(true);

    try {
      const { data } = await axios.get(
        '/api/actuaciones/cierre-dia',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      setCierre(data);
    } catch (error) {
      console.error('Error cargando cierre del día:', error);
      setCierre([]);
    } finally {
      setLoadingCierre(false);
    }
  };

  const cerrarCierre = () => {
    setMostrarCierre(false);
    setCierre([]);
  };

  const totalTarjeta = cierre
    .filter(r => Number(r.n_presupuesto) === 1)
    .reduce((acc, r) => acc + Number(r.total || 0), 0);

  const totalMetalico = cierre
    .filter(r => Number(r.n_presupuesto) === 2)
    .reduce((acc, r) => acc + Number(r.total || 0), 0);

  const totalDia = cierre.reduce(
    (acc, r) => acc + Number(r.total || 0),
    0
  );

  const fechaHoy = new Date().toLocaleDateString('es-ES');
  return (
    <>
    <header className="topbar">
      <div className="topbar-brand">
        <span className="brand-dot"></span>
        <strong>{user || "Usuario"}</strong>
      </div>
      
      <nav className="topbar-nav">
        <NavLink to="/dashboard" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Inicio</NavLink>
        <NavLink to="/pacientes" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Pacientes</NavLink>
        <NavLink to="/calendario" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Calendario</NavLink>
        {canSee && <NavLink to="/facturacion/general" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Facturación</NavLink>}
        <NavLink to="/tratamientos" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Tratamientos</NavLink>
        <NavLink to="/recalls" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Recalls</NavLink>
        {canSee && <NavLink to="/auditoria" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Auditoría</NavLink>}
       	<button
	        className="cierre-dia-button"
	        onClick={abrirCierre}
     	>
            Cierre día
        </button>
      </nav>

      <div className="topbar-right">
        <button className="logout-button" onClick={logout}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px'}}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          Salir
        </button>
      </div>
    </header>
    
    {mostrarCierre && (
        <div className="cierre-overlay">
          <div className="cierre-modal">

            <div className="cierre-header">
              <div>
                <h2>Cierre del día</h2>
                <span>{fechaHoy}</span>
              </div>

              <button
                className="cierre-close"
                onClick={cerrarCierre}
              >
                ×
              </button>
            </div>

            {loadingCierre ? (
              <div className="cierre-loading">
                <div className="cierre-spinner"></div>
                <p>Cargando actuaciones...</p>
              </div>
            ) : cierre.length === 0 ? (
              <div className="cierre-vacio">
                No hay actuaciones pagadas hoy.
              </div>
            ) : (
              <>
                <div className="cierre-tabla-container">
                  <table className="cierre-tabla">
                    <thead>
                      <tr>
                        <th>Paciente</th>
                        <th>Tratamiento</th>
                        <th>Pieza</th>
                        <th>Cantidad</th>
                        <th>Importe</th>
                        <th>Total</th>
                        <th>Pago</th>
                      </tr>
                    </thead>

                    <tbody>
                      {cierre.map((r, index) => {
                        const nombre = [
                          r.nombre,
                          r.primer_apellido,
                          r.segundo_apellido
                        ]
                          .filter(Boolean)
                          .join(' ');

                        return (
                          <tr key={index}>
                            <td>{nombre}</td>

                            <td>{r.tratamiento}</td>

                            <td>
                              {r.n_pieza || '-'}
                            </td>

                            <td className="cierre-numero">
                              {r.cantidad || 1}
                            </td>

                            <td className="cierre-importe">
                              {Number(r.importe || 0).toFixed(2)} €
                            </td>

                            <td className="cierre-total-linea">
                              {Number(r.total || 0).toFixed(2)} €
                            </td>
                            
                            <td>
                              {Number(r.n_presupuesto) === 1 ? (
                                <span className="pago-tarjeta">
                                  Tarjeta
                                </span>
                              ) : Number(r.n_presupuesto) === 2 ? (
                                <span className="pago-metalico">
                                  Metálico
                                </span>
                              ) : (
                                <span>
                                  Sin indicar
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="cierre-resumen">

                  <div className="cierre-resumen-item tarjeta">
                    <span>Tarjeta</span>
                    <strong>
                      {totalTarjeta.toFixed(2)} €
                    </strong>
                  </div>

                  <div className="cierre-resumen-item metalico">
                    <span>Metálico</span>
                    <strong>
                      {totalMetalico.toFixed(2)} €
                    </strong>
                  </div>

                  <div className="cierre-resumen-total">
                    <span>Total del día</span>
                    <strong>
                      {totalDia.toFixed(2)} €
                    </strong>
                  </div>

                </div>
              </>
            )}

            <div className="cierre-footer">
              <button
                className="cierre-cerrar-button"
                onClick={cerrarCierre}
              >
                Cerrar
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}